export enum Product {
    BUS = 'abhibus',
    CAB = 'cab',
    CTKT_TRAIN = 'ctkt_train',
    FLIGHT = 'flight',
    FLIGHT_PRICE_LOCK = 'flight_price_lock',
    HOTEL = 'hotel',
    TRAIN = 'train',
}

export enum BookingStatus {
    AB_BOOKING_SUCCESS = 'AB_BOOKING_SUCCESS',
    AB_CANCEL_REFUND_PENDING = 'AB_CANCEL_REFUND_PENDING',
    AB_CANCEL_REFUND_SUCCESS = 'AB_CANCEL_REFUND_SUCCESS',
    AB_PAYMENT_FAILED = 'AB_PAYMENT_FAILED',
    AB_PAYMENT_PENDING = 'AB_PAYMENT_PENDING',
    AB_PAYMENT_SUCCESS_BOOKING_FAILURE = 'AB_PAYMENT_SUCCESS_BOOKING_FAILURE',
    AB_PAYMENT_SUCCESS_BOOKING_PENDING = 'AB_PAYMENT_SUCCESS_BOOKING_PENDING',
    AB_PAYMENT_SUCCESS_REFUND_PENDING = 'AB_PAYMENT_SUCCESS_REFUND_PENDING',
    AB_PAYMENT_SUCCESS_REFUNDED = 'AB_PAYMENT_SUCCESS_REFUNDED',
    BOOKED = 'BOOKED',
    BOOKING_COMPLETE = 'BOOKING_COMPLETE',
    BOOKING_FAILED = 'BOOKING_FAILED',
    BOOKING_INITIATED = 'BOOKING_INITIATED',
    BOOKING_SUCCESS = 'BOOKING_SUCCESS',
    CANCELLATION_FAILED = 'CANCELLATION_FAILED',
    CANCELLED = 'CANCELLED',
    CONFIRMED = 'CONFIRMED',
    FAILED = 'FAILED',
    FULL_CANCELLED = 'FULL CANCELLED',
    NOT_CONFIRMED = 'NOT CONFIRMED',
    PARTIAL_CANCELLED = 'PARTIAL CANCELLED',
    PARTIAL_CONFIRMED = 'PARTIAL_CONFIRMED',
    PARTIAL_TO_BE_CANCELLED = 'PARTIAL_TO_BE_CANCELLED',
    PARTIALLY_CANCELLED = 'PARTIALLY_CANCELLED',
    PAYMENT_FAILED = 'PAYMENT_FAILED',
    PAYMENT_FAILURE = 'PAYMENT_FAILURE',
    PAYMENT_INITIATED = 'PAYMENT_INITIATED',
    PAYMENT_PENDING = 'PAYMENT_PENDING',
    PAYMENT_PENDING_BOOKING_FAILURE = 'PAYMENT_PENDING_BOOKING_FAILURE',
    PAYMENT_SUCCESS_BOOKING_FAILURE = 'PAYMENT_SUCCESS_BOOKING_FAILURE',
    PAYMENT_SUCCESS_BOOKING_PENDING = 'PAYMENT_SUCCESS_BOOKING_PENDING',
    REFUND_INITIATED = 'REFUND_INITIATED',
    REFUNDED = 'REFUNDED',
    TO_BE_CANCELLED = 'TO_BE_CANCELLED',
    BOOKING_SUCCESSFUL = 'BOOKING_SUCCESSFUL',
    PAYMENT_SUCCESS_BOOKING_FAILED = 'PAYMENT_SUCCESS_BOOKING_FAILED',
    REBOOKED = 'REBOOKED',
    COMPLETED = 'COMPLETED',
}

export enum PriceLockStatus {
    ACTIVE = 'ACTIVE',
    BOOKING_INITIATED = 'BOOKING_INITIATED',
    BOOKING_PENDING = 'BOOKING_PENDING',
    EXPIRED = 'EXPIRED',
    INITIATED = 'INITIATED',
    PAYMENT_FAILED = 'PAYMENT_FAILED',
    PENDING = 'PENDING',
    PRICE_LOCK_REFUNDED = 'PRICE_LOCK_REFUNDED',
    REDEEMED = 'REDEEMED',
}

export enum AiSmartSupport {
    LOADING_START = 'LOADING_START',
    LOADING_SUCCESS = 'LOADING_SUCCESS',
    LOADING_ERROR = 'LOADING_ERROR',
    SET_PENDING_TOAST = 'SET_PENDING_TOAST',
    SHOW_TOAST = 'SHOW_TOAST',
    HIDE_TOAST = 'HIDE_TOAST',
    OPEN_CONTACT_SHEET = 'OPEN_CONTACT_SHEET',
    CLOSE_CONTACT_SHEET = 'CLOSE_CONTACT_SHEET',
    OPEN_HISTORY_DETAIL = 'OPEN_HISTORY_DETAIL',
    CLOSE_HISTORY_DETAIL = 'CLOSE_HISTORY_DETAIL',
    OPEN_BOT_SESSION_DETAIL = 'OPEN_BOT_SESSION_DETAIL',
    CLOSE_BOT_SESSION_DETAIL = 'CLOSE_BOT_SESSION_DETAIL',
    OPEN_CALL_HISTORY_DETAIL = 'OPEN_CALL_HISTORY_DETAIL',
    CLOSE_CALL_HISTORY_DETAIL = 'CLOSE_CALL_HISTORY_DETAIL',
    HIDE_AI_SUMMARY_LABEL = 'HIDE_AI_SUMMARY_LABEL',
}

export enum HotelPaymentType {
    BOOK_WITH_ZERO_PAYMENT = 'BOOK_WITH_ZERO_PAYMENT',
    PAY_NOW = 'PAY_NOW',
}